"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_find_1 = __importDefault(require("lodash.find"));

function find(collection, predicate) {
  return lodash_find_1.default(collection, predicate);
}

exports.find = find;